import React from 'react';

const DEFAULT_IMAGE = "/assets/images/no_image.png";

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  // Use default image if src is missing, null, undefined, or empty string
  const imageSrc = src && src.trim() !== '' ? src : DEFAULT_IMAGE;

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      crossOrigin={imageSrc?.startsWith('http') && !imageSrc?.includes(window.location.hostname) ? 'anonymous' : undefined}
      onError={(e) => {
        // If the default image also fails, keep it as is
        if (e.target.src !== DEFAULT_IMAGE && !e.target.src.includes('no_image.png')) {
          console.log('Image failed to load:', e.target.src);
          e.target.src = DEFAULT_IMAGE;
        }
      }}
      onLoad={() => {
        // Log successful load for debugging
        if (imageSrc?.includes('centris.ca')) {
          console.log('Centris image loaded successfully:', imageSrc);
        }
      }}
      {...props}
    />
  );
}

export default Image;
